import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import './assets/css/reset.css'
import {IsPC, getQueryString} from './assets/js/tool'
import VueI18n from 'vue-i18n'
import { Toast, Dialog , Picker ,Popup , Field } from 'vant';
// import axios from 'axios'
import axios from './assets/js/baseaxios'
import locale from 'element-ui/lib/locale/lang/en'
import { Locale } from 'vant';
import enUS from 'vant/lib/locale/lang/en-US';


if (getQueryString('lang') === 'en') {
  Vue.use(ElementUI, { locale })
  Locale.use('en-US', enUS);
}else{
  Vue.use(ElementUI);
}


Vue.use(VueI18n)
Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Field);
Vue.config.productionTip = false;


const i18n = new VueI18n({
  messages:{
    en: require('./assets/common/lang/en'),
    zh: require('./assets/common/lang/zh')
  }
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  mounted(){
    /*
    * http://192.168.50.7:8080/#/login?lang=en&origin=www.baidu.com
    *
    * lang 语言 en 英文 zh 中文
    * origin 来源
    *
    * */

    //判断是否是建议流程
    let isEasy = getQueryString('isEasy') || this.$store.state.memu.isEasy
    if(isEasy === 'true' || isEasy === true){
      this.$store.commit({
        type: 'setMemu',
        name: 'isEasy',
        value: true
      })
    }else{
      this.$store.commit({
        type: 'setMemu',
        name: 'isEasy',
        value: false
      })
    }
    //判断是从小程序还是PC进来的
    console.log(getQueryString('isXCX'))
    console.log(this.$store.state.memu.isXCX)
    let isXCX = getQueryString('isXCX') || this.$store.state.memu.isXCX
    console.log(isXCX)
    if(isXCX === 'true' || isXCX === true){
      this.$store.commit({
        type: 'setMemu',
        name: 'isXCX',
        value: true
      })
    }else{
      this.$store.commit({
        type: 'setMemu',
        name: 'isXCX',
        value: false
      })
    }
    //判断设备类型
    let bool = IsPC()
    this.$store.commit({
      type: 'setMemu',
      name: 'IsPC',
      value: bool
    })
    //自定义弹窗样式
    if(bool){
      document.getElementsByTagName('html')[0].style['font-size'] = 16 + 'px';
      Toast.setDefaultOptions({
        duration: 2000,
        className: 'myToast'
      });
      Dialog.setDefaultOptions({
        showCancelButton: true,
        className: 'myDialog',
        overlayStyle:{
          background: 'rgba(0,0,0,0.3)'
        },
      })
    }else{
      document.getElementsByTagName('html')[0].style['font-size'] = 13.33333333 + 'vw';
      Toast.setDefaultOptions({
        duration: 2000,
        className: 'myToastMob',
      });
      Dialog.setDefaultOptions({
        showCancelButton: true,
        className: 'myDialogMob'
      })
    }
    //判断语言
    let lang = getQueryString('lang')
    if(lang){
      //url存在lang
      this.$store.commit({
        type: 'setMemu',
        name: 'lang',
        value: lang
      })
      this.$i18n.locale = lang
    }else{
      let vuexLang = store.state.memu.lang
      if(!vuexLang){
        //url，vuex 都不存在lang
        this.$store.commit({
          type: 'setMemu',
          name: 'lang',
          value: 'zh'
        })
        this.$i18n.locale = 'zh'
      }else{
        //url不存在， vuex存在
        this.$i18n.locale = vuexLang
      }
    }
    //获取问卷id
    let questionId = getQueryString('fquestionId')
    if(questionId){
      this.$store.commit({
        type: 'setMemu',
        name: 'fquestionId',
        value: questionId
      })
    }else{
      this.$store.commit({
        type: 'setMemu',
        name: 'fquestionId',
        value: 1
      })
      // this.$toast('未获取到问卷信息，请重试！')
      // return
    }
    //获取来源
    let origin = getQueryString('origin')
    if(origin){
      this.$store.commit({
        type: 'setMemu',
        name: 'origin',
        value: origin
      })
    }
    //调整接口头部信息
    if (this.$store.state.memu.lang == 'en') {
      axios.defaults.headers['Accept-Language'] = 'en-US,en;q=0.9,zh-CN;q=0.8,zh;q=0.7'
    } else {
      axios.defaults.headers['Accept-Language'] = 'zh,en;q=0.9,zh-CN;q=0.8,en-US;q=0.7'
    }
    //设置title
    let title = this.$t('m.title')
    document.title = title
  },
}).$mount('#app')
